// @ts-nocheck
import React from "react";
import { DataQuality } from "@sia/style-guide";

function getLevelQuality(level) {
  const tableMetrics = level?.hourlyAggregationsPerYear?.[0]?.metrics?.table ?? [];

  const metricsWithQuality = tableMetrics.filter(
    (item) => item?.quality && item.quality.count != null && item.quality.coefficientOfVariation != null
  );

  if (metricsWithQuality.length === 0) {
    return null;
  }

  const worstMetric = metricsWithQuality.reduce((worst, current) => {
    return current.quality.coefficientOfVariation > worst.quality.coefficientOfVariation ? current : worst;
  });

  return worstMetric.quality;
}

function buildLevelHeader(level, translate) {
  const quality = getLevelQuality(level);

  return (
    <div className="sia-table-level-header">
      <span>{level.levelName}</span>
      {quality && <DataQuality translate={translate} numberOfRecords={quality.count} coefficient={quality.coefficientOfVariation} compact />}
    </div>
  );
}

export function generateWorkingHoursTableHeader(data, translate, isMasterKeyValid) {
  if (data?.length === 0) {
    return [];
  }

  // first row
  let headerRows = [
    {
      className: "main-header",
      headers: [
        {
          name: " ",
          id: "row-name",
          className: "left-align",
          rowSpan: 2,
          colSpan: 1,
        },
      ],
    },
  ];

  let firstRowCols = data.map((level) => {
    return {
      name: buildLevelHeader(level, translate),
      id: level.levelId,
      className: isMasterKeyValid ? "bold-header no-border" : "bold-header no-border without-ownvalue",
      colSpan: isMasterKeyValid ? 2 : 1,
    };
  });

  headerRows[0].headers.push(...firstRowCols);

  // second row
  headerRows[1] = {
    className: "secondary-header",
    headers: [],
  };

  let secondRowCols = data.map((level) => {
    let averageCol = {
      name: translate("benchmarking.data-table.header-row.average"),
      headers: level.levelId,
      colSpan: 1,
    };
    let ownValueCol = {
      name: translate("benchmarking.evaluations.overheads.table.myOffice"),
      headers: level.levelId,
      colSpan: 1,
    };
    if (isMasterKeyValid) {
      return [averageCol, ownValueCol];
    } else {
      return [averageCol];
    }
  });
  secondRowCols = secondRowCols.flat();

  headerRows[1].headers.push(...secondRowCols);

  return headerRows;
}

export function formatValue(value) {
  const intlFormatter = new Intl.NumberFormat("de-CH", {
    style: "currency",
    currency: "CHF",
    maximumFractionDigits: 1,
  });
  let formattedValue = intlFormatter.format(value);
  let formattedValueWithoutCurrency = formattedValue.replace("CHF", "");
  return formattedValueWithoutCurrency;
}

export function tooltipGenerator(d, refIndex, currentKey, translate, isPercentage) {
  let innerHTML = "";
  let keysToExclude = ["group", "subgroup", "referenceAverages"];

  let filteredEntries = Object.entries(d).filter(([key]) => !keysToExclude.includes(key));

  let groupTotal = filteredEntries.reduce((acc, [_, value]) => {
    acc += value[refIndex];
    return acc;
  }, 0);

  let formattedGroupTotal = formatValue(groupTotal);

  let levelValue = formatValue(d[currentKey][refIndex]);

  // const currentGroupPercentage = (d[currentKey][refIndex] / groupTotal) * 100;

  let averageRow = `
        <div class='sia-stacked-barchart-tooltip-row'>
          <div class='sia-stacked-barchart-tooltip-key'>${d.group}</div>
          <div class='sia-stacked-barchart-tooltip-value'>${formattedGroupTotal}</div>
        </div>
    `;

  innerHTML += `
    <div class='sia-stacked-barchart-tooltip-row-active''>
      <div class='sia-stacked-barchart-tooltip-key'>${currentKey}</div>
      <div class='sia-stacked-barchart-tooltip-value'>${levelValue}</div>
    </div>
    `;

  let groupRow = `
      <div class='sia-stacked-barchart-tooltip-row'>
        <div class='sia-stacked-barchart-tooltip-key'>${translate("benchmarking.barchart.tooltip.group")}</div>
        <div class='sia-stacked-barchart-tooltip-value'>${translate(`benchmarking.stacked-barchart.legend.${d.subgroup}`)}</div>
      </div>
  `;

  innerHTML = averageRow + innerHTML + groupRow;
  return innerHTML;
}
